
    <div class="month-Year-Main">
        <div class="d-flex align-items-center w-100 flex-column">
            <div class="d-flex align-items-center" *ngIf="dealerName">
                <div class="dealerName-wt mr-2"><span translate>lblDealersName</span>:</div>
                <div class="dealerName-wt mr-2">{{dealerName}}</div>
            </div>
            <div class="d-flex align-items-center">
                <button class="btn btn-outline-primary" (click)="onSchedulerPreviousClick()" aria-label="Center Align">
                    <em class="fas fa-arrow-left fa-lg"></em>
                </button>
                <div class="month-Year-child card-header text-center" *ngIf="schedularHeaderInfo">
                    {{schedularHeaderInfo.currentMonth | translate}} - {{ schedularHeaderInfo.currentYear }}
                </div>
                <button class="btn btn-outline-primary" aria-label="Center Align" (click)="onSchedulerNextClick()">
                    <em class="fas fa-arrow-right fa-lg"></em>
                </button>
            </div>
        </div>
    </div>
    <div >
    <ng-container *ngFor="let item of mechanicData">

        <span id="mechanic">{{item.mechanicName}}</span>
        <div class="btmborderfix" >

        
        <div style="overflow: auto; ">

        

        <div [ngClass]="{'d-flex':isScheduleSummary }" class="bg-grey-100 btmborder">
            <div class="dealer-width col-auto"> <label style="align-self: center;">{{'lblDate'|translate}}</label>
            </div>
            <div class="planning-dates col p-0">
                <ul [ngClass]="{'planning-month-scheduleSummary': isScheduleSummary }"
                    class="planning-month d-flex flex-nowrap" id="monthScrollDiv">
                    <ng-container *ngIf="schedularHeaderInfo">
                        <li *ngFor="let item of schedularHeaderInfo.infos;let i=index"
                            [ngClass]="{'monthScrollDiv':i==0}" [attr.id]="item.isCurrent?'scrollToMe':null"
                            [ngClass]="{'selected':item.isCurrent}">
                            <ng-container>
                                <div class="day" [ngClass]="{'state-3': item.isHoliday || item.isCurrent}">
                                    {{item.dayName | translate}}</div>
                            </ng-container>
                            <div class="date" [ngClass]="{'state-selected':item.isCurrent , 'state-3':item.isHoliday}">
                                {{item.cdate}}
                            </div>
                        </li>
                    </ng-container>
                </ul>
            </div>
            <div id="totalHours" class="last-col"> <label style="align-self: center;">{{'lblTotal'|translate}}</label> </div>
        </div>

        <div class="d-flex odd-even">
            <div
                class="testings initialpositionoftable horz-date-day-scheduleSummary col-auto dealer-width btmborder-light">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column justify-content-between " tooltipClass="my-tooltip" container="body">
                        <label [ngClass]="mechanic-not-available" style="align-items: left;" translate>
                            lblInTime
                        </label>
                    </div>
                </div>
            </div>
            
                <ul class="p-0 d-flex btmborder-w col p-0">
                    <li *ngFor="let m of monthDays; let i = index" class="col p-0">
                        <ng-container>
                            <div class="day-cell center-align-cells"
                                [ngStyle]="{'background-color': item.isHoliday[i]  || item.isOnLeave[i] || item.isInActive[i] ? '#bfc2b7' : ''}">
                                <ng-container *ngIf="item.inTime[i] != '-'; else loadDefault">
                                    {{item.inTime[i] | date:'HH:mm'}}
                                </ng-container>
                                <ng-template #loadDefault>
                                    {{item.inTime[i]}}
                                </ng-template>
                            </div>
                        </ng-container>
                    </li>
                </ul>
            
            
            <div id="totalHours" class="last-col col-auto"> <label style="align-self: center;"></label> </div>
        </div>
        <div class="d-flex odd-even">
            <div
                class="testings initialpositionoftable horz-date-day-scheduleSummary col-auto dealer-width btmborder-light">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column justify-content-between " tooltipClass="my-tooltip" container="body">
                        <label [ngClass]="mechanic-not-available" style="align-items: left;" translate>
                            lblOutTime
                        </label>
                    </div>
                </div>
            </div>
            <ul class="p-0 d-flex btmborder-w col p-0">
                <li *ngFor="let m of monthDays; let i = index" class="col p-0">
                    <ng-container>
                        <div class="day-cell center-align-cells"
                            [ngStyle]="{'background-color':item.isHoliday[i]  || item.isOnLeave[i] || item.isInActive[i] ? '#bfc2b7' : ''}">
                            <ng-container *ngIf="item.outTime[i] != '-'; else loadDefault">
                                {{item.outTime[i] | date:'HH:mm'}}
                            </ng-container>
                            <ng-template #loadDefault>
                                {{item.outTime[i]}}
                            </ng-template>
                        </div>
                    </ng-container>
                </li>
            </ul>
            <div id="totalHours" class="last-col col-auto"> <label style="align-self: center;"></label> </div>
        </div>
        <div class="d-flex odd-even" *ngIf="!isUsedForUser">
            <div class="d-flex align-items-center justify-content-between testings initialpositionoftable horz-date-day-scheduleSummary col-auto dealer-width btmborder-light">
                <label [ngClass]="mechanic-not-available" style="align-items: left; font-size: 12px !important;" translate>
                                lblTotalHours
                                <small class="text-muted" translate>lblExclBreak</small>
                            </label>
                <em class="fas fa-info-circle text-dark ml-2"
                    [ngbTooltip]="'lblTotalHoursDescription' | translate"
                    placement="top"
                    container="body"
                    tooltipClass="my-tooltip">
                </em>               
            </div>
            <ul class="p-0 d-flex btmborder-w col p-0">
                <li *ngFor="let m of monthDays; let i = index" class="col p-0">
                    <ng-container>
                        <div class="day-cell center-align-cells"
                            [ngStyle]="{'background-color': item.isHoliday[i]  || item.isOnLeave[i] || item.isInActive[i] ? '#bfc2b7' : ''}">
                            <div>
                                {{item.totalHours[i]}}
                            </div>
                        </div>
                    </ng-container>
                </li>
            </ul>
            <div id="totalHours" class="last-col col-auto"> <label style="align-self: center;">{{totalHours(item.totalHours)}}</label> </div>
        </div>
        <div class="d-flex odd-even" *ngIf="!isUsedForUser">           
            <div class="d-flex align-items-center justify-content-between testings initialpositionoftable horz-date-day-scheduleSummary col-auto dealer-width btmborder-light">
                <label [ngClass]="mechanic-not-available" style="align-items: left; font-size: 12px !important;" translate>
                                lblTotalHours
                                <small class="text-muted" translate>lblInclBreak</small>
                            </label>
                <em class="fas fa-info-circle text-dark ml-2"
                    [ngbTooltip]="'lblTotalHoursInclBreakDescription' | translate"
                    placement="top"
                    container="body"
                    tooltipClass="my-tooltip">
                </em>               
            </div>
            <ul class="p-0 d-flex btmborder-w col p-0">
                <li *ngFor="let m of monthDays; let i = index" class="col p-0">
                    <ng-container>
                        <div class="day-cell center-align-cells"
                            [ngStyle]="{'background-color': item.isHoliday[i]  || item.isOnLeave[i] || item.isInActive[i] ? '#bfc2b7' : ''}">
                            <div>
                                {{addTimeStrings(item.totalHours[i], item.lunchTime[i])}}
                            </div>
                        </div>
                    </ng-container>
                </li>
            </ul>
            <div id="totalHours" class="last-col col-auto"> 
        <label style="align-self: center;">{{getTotalHoursWithLunch(item)}}</label> 
    </div>
        </div>
        <div class="d-flex odd-even">
            <div class="d-flex align-items-center justify-content-between testings initialpositionoftable horz-date-day-scheduleSummary col-auto dealer-width btmborder-light">
                <label class="mechanic-not-available"
                    style="font-size: 0.875rem; line-height: 1.2;" 
                    translate>
                    lblActualInTime
                </label>
                <em class="fas fa-info-circle text-dark ml-2"
                    [ngbTooltip]="'lblActualInTimeDescription' | translate"
                    placement="top"
                    container="body"
                    tooltipClass="my-tooltip">
                </em>               
            </div>
            <ul class="p-0 d-flex btmborder-w col p-0">
                <li *ngFor="let m of monthDays; let i = index" class="col p-0" >
                    <ng-container>
                        <div class="day-cell center-align-cells"
                            [ngStyle]="{'background-color': item.isHoliday[i]  || item.isOnLeave[i] || item.isInActive[i] ? '#bfc2b7' : ''}">
                            <div>
                                {{item.actualInTime[i]}}
                            </div>
                        </div>
                    </ng-container>
                </li>
            </ul>
            <div id="totalHours" class="last-col col-auto"> <label style="align-self: center;">{{totalActualInTime(item)}}</label> </div>
        </div>

        <div class="d-flex odd-even">
            <div class="testings initialpositionoftable horz-date-day-scheduleSummary col-auto dealer-width btmborder-light">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column justify-content-between " tooltipClass="my-tooltip" container="body">
                        <div class="d-flex align-items-center">
                            <label [ngClass]="mechanic-not-available" style="align-items: left;" translate>
                                lblTooltipLunchTime
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <ul class="p-0 d-flex btmborder-w col p-0">
                <li *ngFor="let m of monthDays; let i = index" class="col p-0" >
                    <ng-container>
                        <div class="day-cell center-align-cells"
                            [ngStyle]="{'background-color': item.isHoliday[i]  || item.isOnLeave[i] || item.isInActive[i] ? '#bfc2b7' : ''}">
                            <div>
                                {{item.lunchTime[i]}}
                            </div>
                        </div>
                    </ng-container>
                </li>
            </ul>
            <div id="totalHours" class="last-col col-auto"> <label style="align-self: center;">{{totalLunchTime(item)}}</label> </div>
        </div>
        
        <div class="d-flex odd-even">
            <div class="d-flex align-items-center justify-content-between testings initialpositionoftable horz-date-day-scheduleSummary col-auto dealer-width btmborder-light">
                <label [ngClass]="mechanic-not-available" style="align-items: left;" translate>
                                lblShiftHours
                            </label>
                <em class="fas fa-info-circle text-dark ml-2"
                    [ngbTooltip]="'lblShiftHoursDescription' | translate"
                    placement="top"
                    container="body"
                    tooltipClass="my-tooltip">
                </em>               
            </div>
    <ul class="p-0 d-flex btmborder-w col p-0">
        <li *ngFor="let m of monthDays; let i = index" class="col p-0">
            <ng-container>
                <div class="day-cell center-align-cells"
                    [ngStyle]="{'background-color': item.isHoliday[i]  || item.isOnLeave[i] || item.isInActive[i] ? '#bfc2b7' : ''}">
                    <div>
                        {{item.shiftHours[i]}}
                    </div>
                </div>
            </ng-container>
        </li>
    </ul>
    <div id="totalHours" class="last-col col-auto"> 
        <label style="align-self: center;">{{totalHours(item.shiftHours)}}</label> 
    </div>
</div>
        <div class="d-flex odd-even">
            <div class="d-flex align-items-center justify-content-between testings initialpositionoftable horz-date-day-scheduleSummary col-auto dealer-width btmborder-light">
                <label [ngClass]="mechanic-not-available" style="align-items: left;" translate>
                                lblOverTimeHours
                            </label>
                <em class="fas fa-info-circle text-dark ml-2"
                    [ngbTooltip]="'lblOverTimeHoursDescription' | translate"
                    placement="top"
                    container="body"
                    tooltipClass="my-tooltip">
                </em>               
            </div>
            <ul class="p-0 d-flex btmborder-w col p-0">
                <li *ngFor="let m of monthDays; let i = index" class="col p-0">
                    <ng-container>
                        <div class="day-cell center-align-cells"
                            [ngStyle]="{'background-color':item.isHoliday[i]  || item.isOnLeave[i] || item.isInActive[i] ? '#bfc2b7' : ''}">
                            <div>
                                {{item.overTime[i]}}
                            </div>
                        </div>
                    </ng-container>
                </li>
            </ul>
            <div id="totalHours" class="last-col col-auto"> <label style="align-self: center;">
                    {{totalOverTime(item)}}
                </label> </div>
        </div>
        <div class="d-flex odd-even">
            <div
                class="testings initialpositionoftable horz-date-day-scheduleSummary col-auto dealer-width btmborder-light">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column justify-content-between " tooltipClass="my-tooltip" container="body">
                        <label [ngClass]="mechanic-not-available" style="align-items: left;" translate>
                            lblViewSummary
                        </label>
                    </div>
                </div>
            </div>
            <ul class="p-0 d-flex  btmborder-w col p-0">
                <li *ngFor="let m of monthDays; let i = index" class="col p-0">
                    <ng-container>
                        <div class="day-cell center-align-cells" (click)="ViewDetails(content,m,item)"
                            [ngStyle]="{'background-color': item.isHoliday[i]  || item.isOnLeave[i] || item.isInActive[i] ? '#bfc2b7' : ''}">
                            <div>
                                <em class="fa fa-eye"></em>
                            </div>
                        </div>
                    </ng-container>
                </li>
            </ul>
            <div id="totalHours" class="last-col col-auto"> <label style="align-self: center;"></label> </div>

        </div>
        <!-- view details model -->
        </div>
    </div>
        <ng-template #content let-modal>
            <div class="modal-header">
                <h2 class="modal-title" translate>lblViewSummary</h2>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true">
                        ×
                    </span>
                </button>
            </div>
            <div class="modal-body p-0">
                <div class="d-flex align-items-center w-100 flex-column" style="margin-top: 10px;">
                    <div class="d-flex align-items-center">
                        <div class="dealerName-wt mr-2"><span translate>lblDealersName</span>:</div>
                        <div class="dealerName-wt mr-2">{{dealerName}}</div>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="month-Year-child card-header text-center" *ngIf="schedularHeaderInfo">
                            {{selectedDay}}
                        </div>
                    </div>
                </div>
                <span class="d-flex align-items-center w-100 flex-column" id="mechanic">{{item.mechanicName}}</span>
                <div class="table-responsive max-h50">
                    <table class="tablest1">
                        <thead class="stick-header">
                            <tr>
                                <th style="width: 20%" scope="col" translate>lblWorkOrderNo</th>
                                <th style="width: 20%" scope="col" translate>lblTimeFrom</th>
                                <th style="width: 20%" scope="col" translate>lblTimeTo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="summaryList?.length>0; else load_NotFound_Template">
                                <tr *ngFor="let summaryLists of summaryList; let i=index">
                                    <td>
                                        <ngb-highlight [result]="summaryLists.workOrderNo">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <div *ngIf="summaryLists.inTime">
                                            {{summaryLists.inTime | date:'HH:mm'}}
                                        </div>
                                        <div *ngIf="summaryLists.inTime==null">-</div>
                                    </td>
                                    <td>
                                        <div *ngIf="summaryLists.outTime">
                                            {{summaryLists.outTime | date:'HH:mm'}}
                                        </div>
                                        <div *ngIf="summaryLists.outTime==null">-</div>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_NotFound_Template>
                                <tr>
                                    <td colspan="8" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary mr-sm-2 mb-1" type="button" aria-label="Center Align"
                    (click)="modal.dismiss('Cross click')" translate>
                    lblClose
                </button>
            </div>
        </ng-template>
    </ng-container>
    
</div>